/**
 * Summary stats bar for the Batch Payment list page.
 * Stats reflect current filters (except status field).
 */
function BatchPaymentSummaryBar({ stats = {} }) {
    const { total = 0, processing = 0, exported = 0, reconciling = 0, completed = 0, cancelled = 0 } = stats;

    return (
        <div className="flex flex-wrap items-center gap-4 px-4 py-2 bg-surface rounded-lg border text-sm">
            <span className="text-content-3">
                Tổng: <strong className="text-content-2">{total.toLocaleString()}</strong>
            </span>
            <span className="text-blue-500 border-l pl-4">
                Đang xử lý: <strong>{processing.toLocaleString()}</strong>
            </span>
            <span className="text-orange-500 border-l pl-4">
                Đã xuất file: <strong>{exported.toLocaleString()}</strong>
            </span>
            <span className="text-purple-500 border-l pl-4">
                Đang tra soát: <strong>{reconciling.toLocaleString()}</strong>
            </span>
            <span className="text-green-600 border-l pl-4">
                Hoàn tất: <strong>{completed.toLocaleString()}</strong>
            </span>
            <span className="text-content-3 border-l pl-4">
                Đã huỷ: <strong>{cancelled.toLocaleString()}</strong>
            </span>
        </div>
    );
}

export default BatchPaymentSummaryBar;
